import { Media } from "components/Media/media";
import SearchBox from "components/Search/SearchBox";
import React from "react";
import styles from "./PerkSearch.module.scss";

type Props = {};

const PerkSearch = (props: Props) => {
  return (
    <div className="container">
      <div className={styles.perkSearch}>
        <SearchBox
          specifiedSearch="Perk"
          removePopular
          searchButtonTillSmall
          placeholder="Search Perks"
          inputClass={styles.input}
          containerClass={styles.container}
          resultClass={styles.resultContainer}
        />
      </div>
    </div>
  );
};

export default PerkSearch;
